exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".DSSJg-BtH_BV8MFmnvUXi{display:block;width:300px;min-height:164px!important;max-height:212px!important;height:164px!important}", ""]);
// Exports
exports.locals = {
	"userNoteCalloutStyles": "DSSJg-BtH_BV8MFmnvUXi"
};